<template>
	<RightPane
		v-bind:display="display"
		v-on:close="onClose"
	>
		<ModalVScrollable class="project-list"
			title="案件一覧"
			header_height="115"
			bottom_height="0"
			v-on:close="onClose"
			ref="content"
		>
			<template v-slot:header>
				<v-layout row class="modal-header-filter">
					<v-flex xs10 class="mx-2">
						<v-text-field dark
							clearable height="23" 
							placeholder="名前で検索"
							color="white"
							single-line
							v-model="filter_name"
						></v-text-field>
					</v-flex>
					<v-flex xs2 class="mx-2">
						<v-btn flat icon blue 
							color="white" 
							v-on:click="onClickFiltering">
							<v-icon>filter_list</v-icon>
						</v-btn>
					</v-flex>
				</v-layout>
			</template>
			<template v-if="value">
				<RightPaneProjectListRow v-for="p in filtered_project" 
					:key="p.code" v-bind:item="p"
					v-bind:isSelected="value.project_code === p.code"
					v-bind:watchSlide="watchSlide"
					v-bind:mode=isMode
					v-on:project-selected="onClickProjectSelected"
					v-on:show-project-info="onClickShowProjectInfo"
					v-on:project-list-row-slide="onProjectListRowSlide"
				/>
			</template>
		</ModalVScrollable>
	</RightPane>
</template>
<script>
import RightPane from './RightPane';
import ModalVScrollable from './ModalVScrollable';
import RightPaneProjectListRow from'./RightPaneProjectListRow';
import Util from '../classes/Util';
import {LIST_MODE} from '../classes/Const';
import clonedeep from 'lodash/cloneDeep';

export default {
	name: 'RightPaneProjectList',
	props: [
		"value",
	],
	components: {
		RightPane,
		ModalVScrollable,
		RightPaneProjectListRow,
	},
	data: function() {
		return {
			watchSlide: null,
			filter_name: '',
		}
	},
	methods: {
		onClose: function() {
			this.$emit('close');
			this.filter_name = '';
		},
		onProjectListRowSlide: function(e) {
			this.watchSlide = {
				type: 'slide',
				target: e.target,
				status: e.status,
			};
		},
		onClick: function() {
			return false;
		},
		onClickFiltering: function() {
			return false;
		},
		onClickProjectSelected: function(e) {
			this.$emit('project-selected', e);
		},
		onClickShowProjectInfo: function(e) {
			this.$emit("show-project-info", e);
		},
	},
	computed: {
		display: function() {
			return this.value !== undefined && this.value !== null;
		},
		filtered_project: function() {
			let ret = clonedeep(this.$store.getters['dataProject']);
			if(this.value.mode === LIST_MODE.SELECT) {
				if (this.value.project_code !== null
					&& this.value.project_code !== undefined
					&& String(this.value.project_code).length > 0){
						let obj = ret.filter(p => p.code === this.value.project_code)[0];
						Util.arrayMoveToTop(ret,obj);
				}
			}
			
			if (this.filter_name) {
				ret = ret.filter( row => {
					return row.name.search(Util.replaceEscapeString(this.filter_name)) >= 0;
				});
			}
			
			return ret;
		},
		isFiltering: function() {
			return false;
		},
		isMode: function(){
			if (this.value != null){
				return this.value.mode
			}
			return false;
		}
	},
}
</script>